import { absorber, coercionStub } from './absorber';

// Data snapshots only — anything that hands out a capability (clipboard, geolocation,
// sendBeacon, serviceWorker, ...) falls through to the absorber.
const NAVIGATOR_DATA_FIELDS = new Set([
  'userAgent',
  'language',
  'languages',
  'platform',
  'onLine',
  'cookieEnabled',
  'maxTouchPoints',
  'hardwareConcurrency',
  'deviceMemory',
]);

function readNavigatorField(field: string): unknown {
  try {
    if (typeof window === 'undefined') return undefined;
    return (window.navigator as unknown as Record<string, unknown>)[field];
  } catch {
    return undefined;
  }
}

let cachedMirror: unknown = null;

export function getNavigatorMirror(): unknown {
  if (cachedMirror) return cachedMirror;
  cachedMirror = new Proxy(
    {},
    {
      get(_target, prop) {
        const stub = coercionStub(prop);
        if (stub) return stub;
        if (typeof prop === 'string' && NAVIGATOR_DATA_FIELDS.has(prop)) {
          return readNavigatorField(prop);
        }
        return absorber;
      },
      set() {
        return true;
      },
    },
  );
  return cachedMirror;
}
